export default "__VITE_ASSET__DHJh0e86__";